<template>
  <div class="custom-tag" :style="{ color: color, backgroundColor: bgColor }">
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'CustomTag',

  // 组合 (向选项里合并 property)

  mixins: [],

  // 组件
  components: {},

  // 接口 (组件的接口)

  props: {
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#666'
    },
    bgColor: {
      type: String,
      default: '#F6F6F6'
    }
  },

  // 本地状态 (本地的响应式 property)

  data() {
    return {}
  },

  computed: {},

  // 事件 (通过响应式事件触发的回调)

  watch: {},

  created() {},

  mounted() {},

  // 其他生命周期钩子

  // 非响应式的 property (不依赖响应系统的实例 property)

  methods: {}
}
</script>

<style scoped lang="less">
.custom-tag {
  position: relative;
  border-radius: 4px;
  min-width: 32px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
